/**
 * Returns false.
 *
 * @returns {boolean} false.
 * @example
 * stubFalse() // Returns false
 */
export function stubFalse(): boolean {
  return false;
}
